(() => {
  const storageKey = "vl_agentic_attribution";
  const agentHosts = [
    ["chatgpt.com", "chatgpt"],
    ["chat.openai.com", "chatgpt"],
    ["perplexity.ai", "perplexity"],
    ["copilot.microsoft.com", "microsoft_copilot"],
    ["gemini.google.com", "google_gemini"],
    ["claude.ai", "anthropic_claude"],
    ["meta.ai", "meta_ai"],
    ["shop.app", "shop_ai"],
  ];
  const campaignAliases = [
    ["openai", "chatgpt"],
    ["chatgpt", "chatgpt"],
    ["perplexity", "perplexity"],
    ["copilot", "microsoft_copilot"],
    ["microsoft", "microsoft_copilot"],
    ["gemini", "google_gemini"],
    ["google-ai", "google_gemini"],
    ["claude", "anthropic_claude"],
    ["anthropic", "anthropic_claude"],
    ["meta", "meta_ai"],
    ["shop", "shop_ai"],
  ];

  const safeStorage = {
    get() {
      try {
        return JSON.parse(window.sessionStorage.getItem(storageKey) || "null");
      } catch (_error) {
        return null;
      }
    },
    set(value) {
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(value));
      } catch (_error) {
        // Attribution remains available for the current page when storage is blocked.
      }
    },
  };

  function normalizedHost(value) {
    try {
      return new URL(value).hostname.toLowerCase().replace(/^www\./, "");
    } catch (_error) {
      return "";
    }
  }

  function detectSource() {
    const params = new URLSearchParams(window.location.search);
    const campaignSource = (params.get("utm_source") || "").toLowerCase();
    const campaignMedium = (params.get("utm_medium") || "").toLowerCase();
    const explicitAgent = campaignAliases.find(([alias]) => campaignSource.includes(alias));
    const referrerHost = normalizedHost(document.referrer);
    const referringAgent = agentHosts.find(([host]) => referrerHost === host || referrerHost.endsWith(`.${host}`));

    if (!explicitAgent && !referringAgent && !/(^|[_-])(ai|agent|assistant)([_-]|$)/.test(campaignMedium)) {
      return null;
    }

    return {
      source: explicitAgent?.[1] || referringAgent?.[1] || campaignSource || "agentic",
      referrer_host: referrerHost || null,
      campaign: params.get("utm_campaign") || null,
      landing_path: `${window.location.pathname}${window.location.search}`,
      first_seen_at: new Date().toISOString(),
    };
  }

  function publish(eventName, details = {}) {
    const attribution = safeStorage.get() || detectedAttribution;
    if (!attribution) return;

    const payload = {
      ...attribution,
      ...details,
      event: eventName,
      page_path: window.location.pathname,
      page_type: document.querySelector("main[data-template]")?.dataset.template || "",
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `vl_${eventName}`, ...payload });

    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(`viallock_${eventName}`, payload);
    }
  }

  const detectedAttribution = detectSource();
  const existingAttribution = safeStorage.get();
  if (detectedAttribution && !existingAttribution) {
    safeStorage.set(detectedAttribution);
    publish("agentic_session_start");
  }

  if (safeStorage.get() || detectedAttribution) {
    publish("agentic_page_view");
  }

  window.VialLockAgentic = {
    getAttribution: () => safeStorage.get() || detectedAttribution,
    track: publish,
  };

  document.addEventListener("vl:cart:add", (event) => {
    publish("agentic_add_to_cart", {
      items: Array.isArray(event.detail?.items)
        ? event.detail.items.map((item) => ({ id: String(item.id), quantity: Number(item.quantity) || 1 }))
        : [],
    });
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (form instanceof HTMLFormElement && form.action.includes("/cart/add")) {
      publish("agentic_add_to_cart", {
        variant_id: form.querySelector('[name="id"]')?.value || null,
        quantity: Number(form.querySelector('[name="quantity"]')?.value || 1),
      });
    }
  }, true);

  document.addEventListener("click", (event) => {
    const checkoutLink = event.target.closest('a[href*="/checkout"], button[name="checkout"], [data-vl-cart-primary]');
    if (checkoutLink) publish("agentic_checkout_start");
  }, true);
})();
